module.exports = __webpack_public_path__ + "img/dtddyq-w.3257afa4.svg";